import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

const App = () => <Routes />;

export default App;
